import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

interface PaginationButtonProps {
  active?: boolean;
  'aria-label': string;
  children: ReactNode;
  disabled?: boolean;
  onClick: () => void;
}
export default function PaginationButton({ active, ...rest }: PaginationButtonProps) {
  return (
    <li>
      <Box
        as="button"
        data-active={active}
        fontWeight={active ? 'medium' : 'normal'}
        height="36px"
        mr="2px"
        px={5}
        sx={{
          color: 'darkGray300',
          '&:disabled': {
            color: 'lightGray800',
          },
          '&:hover:not(:disabled), &[data-active="true"]': {
            backgroundColor: 'lightGray50',
            borderRadius: '4px',
          },
        }}
        textAlign="center"
        type="button"
        {...rest}
      />
    </li>
  );
}
